import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import AppContext from 'src/AppContext';
import { ThemeType } from '@gmg/gmg-react-components';

// note that the return value is strange... would have expected notification object...
const mutation = `mutation SetApplicationSettings($input: SetApplicationSettingsInput!) {
    setApplicationSettings(input: $input) {
      settings {
        appKeys
        key
        value
      }
    }
  }`;

export const useSetApplicationTheme = () => {

    const context = useContext(AppContext);

    return useMutation({
        mutationFn: async (theme: ThemeType) => {

            void context.api.graphql({ // note that this must not be awaited, it's a fire-and-forget operation
                query: mutation,
                variables: {
                    input: {
                        settings: {
                            appKeys: ['MIO', 'Admin'],
                            key: 'theme',
                            value: theme,
                        },
                    },
                },
            });
        },
    });
};
